import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import Layout from '../../../app/Layout';
import HeaderContent from '../General/HeaderContent';
import Breadcrumb from '../General/Breadcrumb';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMailBulk, faPen, faCheck, faTimes, faFire } from '@fortawesome/free-solid-svg-icons';
import { Badge } from 'react-bootstrap';
import SpinnerLoading from '../../components/Spinners/SpinnerLoading';
import ModalBasicwithRedux from '../../../containers/ModalBasicwithRedux';
import ModalLargewhithRedux from '../../../containers/ModalLargewhithRedux';
import Swal from 'sweetalert2';
import {
  guardarGestion,
  convertirEnContacto,
  listarEstados,
  listarFases,
  listarObservaciones,
  registrarClick,
  traerDetallesLead,
  actualizarNombreLead,
} from '../../../actions/leadsActions';
import { listarProyectos } from '../../../actions/cursosActions';
import { updateStateModalLarge } from '../../../actions/modalActions';
import FormularioDatosCorreo from './FormularioDatosCorreo';
import './Trabajadores.scss';

const DetallesLead = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const focusLlamadaId = new URLSearchParams(location.search).get('llamada');
  const reprogramarLlamadaId = new URLSearchParams(location.search).get('reprogramar');
  const { id_lead } = useParams();
  const { usuario } = useSelector(state => state.usuario);
  const { proyectos } = useSelector(state => state.cursos);
  const { estados, observaciones, leads, fases } = useSelector(state => state.leads);

  const [lead, setLead] = useState({});
  const [loading, setLoading] = useState(true);
  const [currentLeadId, setCurrentLeadId] = useState(id_lead);

  // CA09: call panel state
  const [timerActive, setTimerActive] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [inicioConversacion, setInicioConversacion] = useState(0);
  const [resultado, setResultado] = useState(null); // 'respondio' | 'no_respondio'
  const timerRef = useRef(null);

  // CA11, CA12, CA13: gestión form
  const [estado, setEstado] = useState('');
  const [proposito, setProposito] = useState('');
  const [nota, setNota] = useState('');

  // CA14: programar seguimiento
  const [fechaProg, setFechaProg] = useState('');
  const [horaProg, setHoraProg] = useState('');
  const [motivoProg, setMotivoProg] = useState('');

  // CA17: change tracking
  const [hasChanges, setHasChanges] = useState(false);
  const [guardando, setGuardando] = useState(false);

  // Edición inline del nombre
  const [editandoNombre, setEditandoNombre] = useState(false);
  const [nombreEdit, setNombreEdit] = useState('');
  const [apellidoEdit, setApellidoEdit] = useState('');

  const handleEditarNombre = () => {
    setNombreEdit(lead.nombres || '');
    setApellidoEdit(lead.apellidos || '');
    setEditandoNombre(true);
  };

  const handleGuardarNombre = async () => {
    const ok = await dispatch(actualizarNombreLead(lead.id_lead, nombreEdit, apellidoEdit));
    if (ok) {
      setLead(prev => ({ ...prev, nombres: nombreEdit, apellidos: apellidoEdit }));
      setEditandoNombre(false);
    }
  };

  // CA09: tarjeta inline "Convertir a trato"
  const [mostrarConversion, setMostrarConversion] = useState(false);
  const [convFase, setConvFase] = useState('');
  const [convImporte, setConvImporte] = useState('');
  const [convFechaCierre, setConvFechaCierre] = useState('');
  const [convProducto, setConvProducto] = useState('');

  // CA07/RN03: mensaje de contexto cuando viene desde un seguimiento pendiente
  const [llamadaActivaMsg, setLlamadaActivaMsg] = useState(null);
  // CA08: id de la llamada pendiente que se está gestionando (para marcarla completada)
  const [activeLlamadaId, setActiveLlamadaId] = useState(null);

  // Modal gestionar llamada desde historial
  const [modalLlamada, setModalLlamada] = useState(null);
  const [mResultado, setMResultado] = useState(null);
  const [mProposito, setMProposito] = useState('');
  const [mEstado, setMEstado] = useState('');
  const [mNota, setMNota] = useState('');
  const [mFechaProg, setMFechaProg] = useState('');
  const [mHoraProg, setMHoraProg] = useState('');
  const [mMotivoProg, setMMotivoProg] = useState('');
  const [mGuardando, setMGuardando] = useState(false);
  const [mSeconds, setMSeconds] = useState(0);
  const [mTimerActive, setMTimerActive] = useState(false);
  const [mInicioConversacion, setMInicioConversacion] = useState(0);
  const mTimerRef = useRef(null);

  // currentLeadIndex derived from leads array (always stays in sync after CA05 removal)
  const currentLeadIndex = leads.findIndex(l => String(l.id_lead) === String(currentLeadId));

  // timer effect
  useEffect(() => {
    if (timerActive) {
      timerRef.current = setInterval(() => setSeconds(prev => prev + 1), 1000);
    } else {
      clearInterval(timerRef.current);
    }
    return () => clearInterval(timerRef.current);
  }, [timerActive]);

  // Timer del modal
  useEffect(() => {
    if (mTimerActive) {
      mTimerRef.current = setInterval(() => setMSeconds(prev => prev + 1), 1000);
    } else {
      clearInterval(mTimerRef.current);
    }
    return () => clearInterval(mTimerRef.current);
  }, [mTimerActive]);

  // CA07/RN03: scroll y pre-cargar formulario cuando viene desde seguimiento pendiente
  useEffect(() => {
    if (!focusLlamadaId || loading) return;
    const el = document.getElementById(`ll-${focusLlamadaId}`);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (lead.llamadas) {
      const ll = lead.llamadas.find(l => String(l.id_llamada) === focusLlamadaId);
      if (ll && ll.completado !== '1') {
        if (ll.anotaciones) { setNota(ll.anotaciones); setHasChanges(true); }
        setLlamadaActivaMsg(`Seguimiento programado: ${(ll.fecha_hora || '').split(' ')[0]}`);
      }
    }
  }, [loading, focusLlamadaId]);

  // CA17: auto-reprogramar cuando viene desde el reporte con ?reprogramar=X
  useEffect(() => {
    if (!reprogramarLlamadaId || loading) return;
    if (lead.llamadas) {
      const ll = lead.llamadas.find(l => String(l.id_llamada) === reprogramarLlamadaId);
      if (ll && ll.completado !== '1') handleReprogramar(ll);
    }
  }, [loading, reprogramarLlamadaId]); // eslint-disable-line react-hooks/exhaustive-deps

  const resetCallState = () => {
    setTimerActive(false);
    clearInterval(timerRef.current);
    setSeconds(0);
    setInicioConversacion(0);
    setResultado(null);
  };

  const resetGestionState = () => {
    setProposito('');
    setNota('');
    setFechaProg('');
    setHoraProg('');
    setMotivoProg('');
    setHasChanges(false);
    setLlamadaActivaMsg(null);
    setMostrarConversion(false);
    setActiveLlamadaId(null);
  };

  const formatTime = (s) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m < 10 ? '0' + m : m}:${sec < 10 ? '0' + sec : sec}`;
  };

  const formatTiempo = (secs) => {
    const m = Math.floor((secs % 3600) / 60);
    const s = Math.ceil(secs % 60);
    return `${m < 10 ? '0' + m : m}:${s < 10 ? '0' + s : s}`;
  };

  const fetchLeadDetails = async (leadId) => {
    setLoading(true);
    const datosLead = await dispatch(traerDetallesLead(leadId));
    if (datosLead) {
      const l = datosLead[0];
      setLead(l);
      setEstado(l.estado || '');
      setNota(l.notas || '');
      setLoading(false);
    }
  };

  // CA08: reset all state when lead changes
  useEffect(() => {
    dispatch(listarEstados());
    dispatch(listarFases());
    dispatch(listarObservaciones());
    dispatch(listarProyectos());
    fetchLeadDetails(currentLeadId);
    resetCallState();
    resetGestionState();
  }, [currentLeadId]);

  const handleLeadChange = (evt) => {
    setLead({ ...lead, [evt.target.name]: evt.target.value });
    setHasChanges(true);
  };

  // CA15: single save action
  const handleGuardar = async (e) => {
    e.preventDefault();
    // RN01: los 4 campos son obligatorios para considerar un lead gestionado
    if (!resultado) {
      Swal.fire({ icon: 'warning', title: 'Resultado requerido', text: 'Marca si el lead Respondió o No respondió.' });
      return;
    }
    if (!proposito) {
      Swal.fire({ icon: 'warning', title: 'Propósito requerido', text: 'Selecciona un propósito antes de guardar.' });
      return;
    }
    if (!estado) {
      Swal.fire({ icon: 'warning', title: 'Estado requerido', text: 'Selecciona el estado del lead.' });
      return;
    }
    if (!nota || nota.trim() === '') {
      Swal.fire({ icon: 'warning', title: 'Nota requerida', text: 'Agrega una nota de gestión antes de guardar.' });
      return;
    }

    setGuardando(true);
    const tiempoConversado = inicioConversacion > 0 ? seconds - inicioConversacion : 0;

    const datosGestion = {
      id_lead: lead.id_lead,
      id_usuario: usuario.id_usuario,
      id_llamada: activeLlamadaId || null,
      proposito,
      nota,
      estado,
      segundos: seconds,
      tiempoConversado: tiempoConversado > 0 ? tiempoConversado : 0,
      respondio: resultado === 'respondio',
      fechaProg,
      horaProg,
      motivoProg,
      nombres: lead.nombres,
      apellidos: lead.apellidos,
      correo: lead.correo,
      producto: lead.producto,
      observacion_l: lead.observacion_l,
      telefono: lead.telefono,
    };

    // Use old leads snapshot before Redux removes the lead
    const oldLeads = leads;
    const oldIndex = oldLeads.findIndex(l => String(l.id_lead) === String(currentLeadId));

    const rpta = await dispatch(guardarGestion(datosGestion, lead));
    setGuardando(false);

    if (rpta && rpta.exito) {
      // CA16: success message
      await Swal.fire({
        icon: 'success',
        title: 'Gestión guardada',
        text: 'Lead descontado de la cola pendiente.',
        timer: 1800,
        showConfirmButton: false,
      });
      resetCallState();
      resetGestionState();

      // CA07: navigate to next pending lead
      const nextLead = oldLeads[oldIndex + 1];
      const prevLead = oldLeads[oldIndex - 1];
      if (nextLead) {
        setCurrentLeadId(nextLead.id_lead);
      } else if (prevLead) {
        setCurrentLeadId(prevLead.id_lead);
      } else {
        history.push('/leads');
      }
    }
  };

  // CA17: warn before Siguiente if unsaved
  const handleSiguiente = () => {
    if (hasChanges) {
      Swal.fire({
        icon: 'warning',
        title: '¿Continuar sin guardar?',
        text: 'Tienes cambios sin guardar en este lead.',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar',
      }).then(r => { if (r.isConfirmed) doSiguiente(); });
      return;
    }
    doSiguiente();
  };

  const doSiguiente = () => {
    if (currentLeadIndex === -1 || leads.length === 0) { history.push('/leads'); return; }
    if (currentLeadIndex < leads.length - 1) {
      setCurrentLeadId(leads[currentLeadIndex + 1].id_lead);
    } else {
      Swal.fire({ icon: 'info', title: 'No hay más leads', timer: 1500, showConfirmButton: false });
    }
  };

  const handleEnviarCorreo = () => {
    dispatch(updateStateModalLarge(<FormularioDatosCorreo registro={lead} />, 'Enviar correo'));
  };

  const handleRegistrarClick = (tipo) => {
    dispatch(registrarClick({ autor: usuario.id_usuario, id_lead: lead.id_lead, tipo }));
  };

  // CA16: badge Vencida cuando seguimiento pendiente tiene fecha pasada
  const esVencida = (ll) => {
    if (ll.completado === '1') return false;
    if (!ll.fecha_hora) return false;
    return ll.fecha_hora.split(' ')[0] < new Date().toISOString().split('T')[0];
  };

  // CA17: pre-llenar Programar Seguimiento desde el historial o reporte
  const handleReprogramar = (ll) => {
    const [fecha, hora] = (ll.fecha_hora || '').split(' ');
    setFechaProg(fecha || '');
    setHoraProg(hora ? hora.substring(0, 5) : '');
    setMotivoProg(ll.anotaciones ? `Reprog: ${ll.anotaciones.substring(0, 60)}` : 'Reprogramación');
    setHasChanges(true);
    const elProg = document.getElementById('programar-seguimiento');
    if (elProg) elProg.scrollIntoView({ behavior: 'smooth' });
  };

  // CA06: gestionar una llamada pendiente desde el historial — abre modal
  const handleGestionar = (ll) => {
    setModalLlamada(ll);
    setMResultado(null);
    setMProposito('');
    setMEstado(lead.estado || '');
    setMNota(ll.anotaciones || '');
    setMFechaProg('');
    setMHoraProg('');
    setMMotivoProg('');
    setMSeconds(0);
    setMTimerActive(true);
    setMInicioConversacion(0);
  };

  const handleCerrarModal = () => {
    setMTimerActive(false);
    setMSeconds(0);
    setMInicioConversacion(0);
    setModalLlamada(null);
  };

  const handleGuardarModal = async () => {
    if (!mResultado) {
      Swal.fire({ icon: 'warning', title: 'Resultado requerido', text: 'Marca si el lead Respondió o No respondió.' });
      return;
    }
    if (!mProposito) {
      Swal.fire({ icon: 'warning', title: 'Propósito requerido', text: 'Selecciona un propósito.' });
      return;
    }
    if (!mEstado) {
      Swal.fire({ icon: 'warning', title: 'Estado requerido', text: 'Selecciona el estado del lead.' });
      return;
    }
    if (!mNota || mNota.trim() === '') {
      Swal.fire({ icon: 'warning', title: 'Nota requerida', text: 'Agrega una nota de gestión.' });
      return;
    }
    setMTimerActive(false);
    setMGuardando(true);
    const mTiempoConversado = mInicioConversacion > 0 ? mSeconds - mInicioConversacion : 0;
    const datosGestion = {
      id_lead: lead.id_lead,
      id_usuario: usuario.id_usuario,
      id_llamada: modalLlamada.id_llamada,
      proposito: mProposito,
      nota: mNota,
      estado: mEstado,
      segundos: mSeconds,
      tiempoConversado: mTiempoConversado > 0 ? mTiempoConversado : 0,
      respondio: mResultado === 'respondio',
      fechaProg: mFechaProg,
      horaProg: mHoraProg,
      motivoProg: mMotivoProg,
      nombres: lead.nombres,
      apellidos: lead.apellidos,
      correo: lead.correo,
      producto: lead.producto,
      observacion_l: lead.observacion_l,
      telefono: lead.telefono,
    };
    const rpta = await dispatch(guardarGestion(datosGestion, lead));
    setMGuardando(false);
    if (rpta && rpta.exito) {
      setModalLlamada(null);
      await Swal.fire({ icon: 'success', title: 'Gestión guardada', timer: 1500, showConfirmButton: false });
      fetchLeadDetails(currentLeadId);
    }
  };

  // CA09: toggle tarjeta inline de conversión
  const handleConvertir = () => {
    const siguiente = !mostrarConversion;
    setMostrarConversion(siguiente);
    if (siguiente) {
      setConvProducto(String(lead.producto || ''));
      setTimeout(() => { const elConv = document.getElementById('convertir-trato'); if (elConv) elConv.scrollIntoView({ behavior: 'smooth' }); }, 100);
    }
  };

  const handleConvertirGuardar = async () => {
    if (!convProducto || !convFase || !convImporte || !convFechaCierre) {
      Swal.fire({ icon: 'warning', title: 'Campos requeridos', text: 'Completa producto, fase, monto y fecha de ejecución.' });
      return;
    }
    const datosConversion = {
      lead: lead.id_lead,
      nombres: lead.nombres,
      apellidos: lead.apellidos,
      id_usuario: usuario.id_usuario,
      id_tp_nivel_usuario: usuario.id_tp_nivel_usuario,
      importe: convImporte,
      fase: convFase,
      fecha_cierre: convFechaCierre,
      producto: convProducto || lead.producto || '',
    };
    await dispatch(convertirEnContacto(datosConversion, leads));
    await Swal.fire({ icon: 'success', title: 'Lead convertido a trato', timer: 1800, showConfirmButton: false });
    history.push('/leads');
  };

  return (
    <Layout>
      <div className="Trabajadores">
        <div className="Trabajadores__container">
          <div className="Trabajadores__head">
            <HeaderContent title="Detalle de Lead" icon="group" />
            <Breadcrumb link={[
              { url: '/inicio', nombre: 'Inicio', icon: 'fas fa-home' },
              { url: '/leads', nombre: 'Leads' },
              { url: '', nombre: 'Detalle' },
            ]} />
          </div>
          <div className="Trabajadores__body container-fluid px-0 content-actions mt-1">
            <ModalBasicwithRedux />
            <ModalLargewhithRedux />
            <SpinnerLoading loading={loading}>
              <form onSubmit={handleGuardar}>
                <div className="row">

                  {/* ── LEFT PANEL ── */}
                  <div className="col-md-5">

                    {/* CA19: Datos del Lead */}
                    <div className="box mt-2 p-3">
                      <h5 style={{ borderBottom: '1px solid #eee', paddingBottom: '8px', color: '#434343' }}>
                        <i className="fas fa-user mr-2"></i>Datos del Lead
                      </h5>
                      <div className="form-group mb-2">
                        <label className="mb-1">
                          Nombre completo:
                          {Number(lead.lead_caliente) === 1 && (
                            <Badge
                              pill
                              style={{ backgroundColor: '#fd7e14', color: '#fff', marginLeft: 6 }}
                              title="Lead caliente"
                            >
                              <FontAwesomeIcon icon={faFire} />
                            </Badge>
                          )}
                        </label>
                        {editandoNombre ? (
                          <div>
                            <div className="input-group input-group-sm mb-1">
                              <input type="text" className="form-control" placeholder="Nombres"
                                value={nombreEdit} onChange={e => setNombreEdit(e.target.value)} autoFocus />
                            </div>
                            <div className="input-group input-group-sm">
                              <input type="text" className="form-control" placeholder="Apellidos"
                                value={apellidoEdit} onChange={e => setApellidoEdit(e.target.value)} />
                              <div className="input-group-append">
                                <button type="button" className="btn btn-success" onClick={handleGuardarNombre} title="Guardar">
                                  <FontAwesomeIcon icon={faCheck} />
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={() => setEditandoNombre(false)} title="Cancelar">
                                  <FontAwesomeIcon icon={faTimes} />
                                </button>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="input-group input-group-sm">
                            <input type="text" className="form-control"
                              value={`${lead.nombres || ''} ${lead.apellidos || ''}`} readOnly />
                            <div className="input-group-append">
                              <button type="button" className="btn btn-outline-secondary" onClick={handleEditarNombre} title="Editar nombre">
                                <FontAwesomeIcon icon={faPen} />
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="form-group mb-2">
                        <label className="mb-1">Teléfono:</label>
                        <div className="input-group input-group-sm">
                          <input type="text" className="form-control" value={lead.telefono || ''} readOnly />
                          <div className="input-group-append">
                            <a href={`tel:+${lead.telefono}`} className="btn btn-warning" title="Llamar por teléfono">
                              <i className="fas fa-mobile-alt"></i>
                            </a>
                            <a href={`https://api.whatsapp.com/send/?phone=${lead.telefono}`}
                              className="btn btn-success" target="_blank" rel="noopener noreferrer"
                              title="WhatsApp" onClick={() => handleRegistrarClick(1)}>
                              <i className="fab fa-whatsapp"></i>
                            </a>
                            <button type="button" className="btn btn-info" onClick={handleEnviarCorreo} title="Enviar correo">
                              <FontAwesomeIcon icon={faMailBulk} />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="form-group mb-2">
                        <label className="mb-1">Correo:</label>
                        <input type="email" className="form-control form-control-sm"
                          name="correo" value={lead.correo || ''} onChange={handleLeadChange} />
                      </div>
                      <div className="form-group mb-2">
                        <label className="mb-1">Producto:</label>
                        <select name="producto" className="form-control form-control-sm"
                          value={lead.producto || ''} onChange={handleLeadChange}>
                          {proyectos.map((p, i) => (
                            <option key={i} value={p.id_proyecto}>{p.nombre_proyecto}</option>
                          ))}
                        </select>
                      </div>
                      <small className="text-muted">
                        Tiempo acumulado: <strong>{formatTiempo(lead.tiempo_llamada || 0)}</strong>
                      </small>
                    </div>

                    {/* CA09, CA10: Llamada Actual */}
                    <div id="llamada-actual" className="box mt-2 p-3">
                      <h5 style={{ borderBottom: '1px solid #eee', paddingBottom: '8px', color: '#434343' }}>
                        <i className="fas fa-phone mr-2"></i>Llamada Actual
                      </h5>
                      {llamadaActivaMsg && (
                        <div className="alert alert-info py-1 px-2 mb-2" style={{ fontSize: '12px' }}>
                          <i className="fas fa-calendar-check mr-1"></i>{llamadaActivaMsg}
                        </div>
                      )}
                      <div className="d-flex align-items-center flex-wrap" style={{ gap: '8px' }}>
                        <button type="button"
                          className={`btn btn-sm ${timerActive ? 'btn-danger' : 'btn-success'}`}
                          onClick={() => { setTimerActive(v => !v); setHasChanges(true); }}>
                          <i className={`fas fa-${timerActive ? 'phone-slash' : 'phone'} mr-1`}></i>
                          {timerActive ? 'Colgar' : 'Llamar'}
                        </button>
                        <button type="button" className="btn btn-sm btn-secondary"
                          onClick={resetCallState}>
                          <i className="fas fa-undo mr-1"></i>Reiniciar
                        </button>
                        <span className="font-weight-bold ml-1">
                          <i className="fas fa-stopwatch mr-1"></i>{formatTime(seconds)}
                        </span>
                      </div>
                      {/* CA10: resultado rápido */}
                      <div className="d-flex mt-3" style={{ gap: '8px' }}>
                        <button type="button"
                          className={`btn btn-sm ${resultado === 'respondio' ? 'btn-primary' : 'btn-outline-primary'}`}
                          onClick={() => {
                            setResultado('respondio');
                            setInicioConversacion(seconds);
                            setHasChanges(true);
                          }}>
                          <i className="fas fa-check mr-1"></i>Respondió
                        </button>
                        <button type="button"
                          className={`btn btn-sm ${resultado === 'no_respondio' ? 'btn-warning' : 'btn-outline-warning'}`}
                          onClick={() => {
                            setResultado('no_respondio');
                            setProposito('4'); // RN03: auto-aplica "No contactado"
                            setHasChanges(true);
                          }}>
                          <i className="fas fa-times mr-1"></i>No respondió
                        </button>
                      </div>
                      {resultado && (
                        <div className="mt-2">
                          <span className={`badge badge-${resultado === 'respondio' ? 'primary' : 'warning'}`}>
                            {resultado === 'respondio' ? '✓ Respondió' : '✗ No respondió'}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* ── RIGHT PANEL ── */}
                  <div className="col-md-7">

                    {/* CA11–CA13, CA15: Gestión Comercial */}
                    <div className="box mt-2 p-3">
                      <h5 style={{ borderBottom: '1px solid #eee', paddingBottom: '8px', color: '#434343' }}>
                        <i className="fas fa-clipboard-list mr-2"></i>Gestión Comercial
                      </h5>
                      <div className="row">
                        <div className="col-md-6 mb-2">
                          <label className="mb-1">Estado:</label>
                          <select className="form-control form-control-sm"
                            value={estado}
                            onChange={e => { setEstado(e.target.value); setHasChanges(true); }}>
                            <option value="">Seleccionar...</option>
                            {estados.map((e, i) => (
                              <option key={i} value={e.id_estado}>{e.nombre_estado}</option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-6 mb-2">
                          {/* CA11: propósito obligatorio */}
                          <label className="mb-1">
                            Propósito: <span className="text-danger">*</span>
                          </label>
                          <select className="form-control form-control-sm"
                            value={proposito}
                            onChange={e => { setProposito(e.target.value); setHasChanges(true); }}>
                            <option value="">Seleccionar...</option>
                            <option value="2">Venta</option>
                            <option value="3">Seguimiento de venta</option>
                            <option value="1">Posventa</option>
                            <option value="4">No contactado</option>
                          </select>
                        </div>
                        {String(estado) === '5' && (
                          <div className="col-12 mb-2">
                            <label className="mb-1">Observaciones:</label>
                            <select name="observacion_l" className="form-control form-control-sm"
                              value={lead.observacion_l || ''} onChange={handleLeadChange}>
                              {observaciones.map((o, i) => (
                                <option key={i} value={o.id_observacion}>{o.observacion_n}</option>
                              ))}
                            </select>
                          </div>
                        )}
                        {/* CA12, CA13: único campo de nota */}
                        <div className="col-12 mb-2">
                          <label className="mb-1">Nota de gestión:</label>
                          <textarea className="form-control form-control-sm" rows={3}
                            value={nota}
                            onChange={e => { setNota(e.target.value); setHasChanges(true); }}
                            placeholder="Anota el resultado de esta gestión..." />
                        </div>
                      </div>
                    </div>

                    {/* CA14: Programar Seguimiento (inline) */}
                    <div id="programar-seguimiento" className="box mt-2 p-3" style={resultado === 'no_respondio' ? { border: '2px solid #ffc107', borderRadius: '4px' } : {}}>
                      <h5 style={{ borderBottom: '1px solid #eee', paddingBottom: '8px', color: '#434343' }}>
                        <i className="fas fa-calendar-alt mr-2"></i>Programar Seguimiento
                        {resultado === 'no_respondio'
                          ? <small className="text-warning ml-2" style={{ fontSize: '12px' }}><i className="fas fa-exclamation-circle mr-1"></i>Agenda la próxima llamada</small>
                          : <small className="text-muted ml-2" style={{ fontSize: '12px' }}>(opcional)</small>
                        }
                      </h5>
                      <div className="row">
                        <div className="col-md-4 mb-2">
                          <label className="mb-1">Fecha:</label>
                          <input type="date" className="form-control form-control-sm"
                            value={fechaProg}
                            onChange={e => { setFechaProg(e.target.value); setHasChanges(true); }} />
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="mb-1">Hora:</label>
                          <input type="time" className="form-control form-control-sm"
                            value={horaProg}
                            onChange={e => { setHoraProg(e.target.value); setHasChanges(true); }} />
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="mb-1">Motivo:</label>
                          <input type="text" className="form-control form-control-sm"
                            value={motivoProg} placeholder="Motivo..."
                            onChange={e => { setMotivoProg(e.target.value); setHasChanges(true); }} />
                        </div>
                      </div>
                    </div>

                    {/* CA09: Convertir a trato — tarjeta inline */}
                    {mostrarConversion && (
                      <div id="convertir-trato" className="box mt-2 p-3" style={{ border: '2px solid #28a745', borderRadius: '4px' }}>
                        <h5 style={{ borderBottom: '1px solid #eee', paddingBottom: '8px', color: '#155724' }}>
                          <i className="fas fa-user-check mr-2"></i>Convertir a trato
                          <small className="text-muted ml-2" style={{ fontSize: '12px' }}>(RN04: el lead saldrá de la lista de pendientes)</small>
                        </h5>
                        <div className="row">
                          <div className="col-md-6 mb-2">
                            <label className="mb-1">Producto: <span className="text-danger">*</span></label>
                            <select className="form-control form-control-sm" value={convProducto} onChange={e => setConvProducto(e.target.value)}>
                              <option value="">Seleccionar...</option>
                              {proyectos.map((p, i) => <option key={i} value={p.id_proyecto}>{p.nombre_proyecto}</option>)}
                            </select>
                          </div>
                          <div className="col-md-6 mb-2">
                            <label className="mb-1">Fase inicial: <span className="text-danger">*</span></label>
                            <select className="form-control form-control-sm" value={convFase} onChange={e => setConvFase(e.target.value)}>
                              <option value="">Seleccionar...</option>
                              {fases && fases.map((f, i) => <option key={i} value={f.id_fase}>{f.nombre_mostrar}</option>)}
                            </select>
                          </div>
                          <div className="col-md-6 mb-2">
                            <label className="mb-1">Monto: <span className="text-danger">*</span></label>
                            <input type="number" className="form-control form-control-sm" value={convImporte}
                              placeholder="0.00" min="0" step="0.01"
                              onChange={e => setConvImporte(e.target.value)} />
                          </div>
                          <div className="col-md-6 mb-2">
                            <label className="mb-1">Fecha de ejecución: <span className="text-danger">*</span></label>
                            <input type="date" className="form-control form-control-sm" value={convFechaCierre}
                              onChange={e => setConvFechaCierre(e.target.value)} />
                          </div>
                          <div className="col-12 d-flex mt-1" style={{ gap: '8px' }}>
                            <button type="button" className="btn btn-success btn-sm" onClick={handleConvertirGuardar}>
                              <i className="fas fa-check mr-1"></i>Guardar trato
                            </button>
                            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => setMostrarConversion(false)}>
                              Cancelar
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* CA18: Historial (solo del lead actual, desde API) */}
                    <div className="box mt-2 p-3">
                      <h5 style={{ borderBottom: '1px solid #eee', paddingBottom: '8px', color: '#434343' }}>
                        <i className="fas fa-history mr-2"></i>Historial de Gestiones
                      </h5>
                      {lead.llamadas && lead.llamadas.length > 0 ? (
                        <div className="table-responsive">
                          <table className="table table-sm table-striped mb-0">
                            <thead>
                              <tr>
                                <th>Fecha</th>
                                <th>Propósito</th>
                                <th>Duración</th>
                                <th>Nota</th>
                                <th>Estado</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {lead.llamadas.map((ll, i) => (
                                <tr key={i} id={`ll-${ll.id_llamada}`}
                                  style={String(ll.id_llamada) === focusLlamadaId
                                    ? { background: '#fff3cd', outline: '2px solid #ffc107' }
                                    : {}}>
                                  <td style={{ whiteSpace: 'nowrap' }}>{ll.fecha_hora || '—'}</td>
                                  <td>{ll.nombre_proposito || '—'}</td>
                                  <td style={{ whiteSpace: 'nowrap' }}>{formatTiempo(ll.tiempo_llamada || 0)}</td>
                                  <td style={{ maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                    title={ll.anotaciones}>{ll.anotaciones || '—'}</td>
                                  <td>
                                    <span className={`badge badge-${ll.completado === '1' ? 'success' : esVencida(ll) ? 'danger' : 'warning'}`}>
                                      {ll.completado === '1' ? 'Completado' : esVencida(ll) ? 'Vencida' : 'Pendiente'}
                                    </span>
                                  </td>
                                  <td>
                                    {ll.completado !== '1' && (
                                      <div className="d-flex" style={{ gap: '3px' }}>
                                        <button type="button" className="btn btn-xs btn-primary"
                                          title="Gestionar esta llamada" onClick={() => handleGestionar(ll)}>
                                          <i className="fas fa-phone"></i>
                                        </button>
                                        <button type="button" className="btn btn-xs btn-outline-secondary"
                                          title="Reprogramar" onClick={() => handleReprogramar(ll)}>
                                          <i className="fas fa-calendar-plus"></i>
                                        </button>
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <p className="text-muted mb-0">No hay gestiones registradas.</p>
                      )}
                    </div>
                  </div>
                </div>

                {/* CA15: barra de acciones única */}
                <div className="row mt-3 mb-3">
                  <div className="col-12 d-flex justify-content-between align-items-center">
                    <button type="button" className="btn btn-outline-secondary"
                      onClick={() => history.push('/leads')}>
                      <i className="fas fa-arrow-left mr-1"></i>Volver a lista
                    </button>
                    <div>
                      <button type="button" className={`btn mr-2 ${mostrarConversion ? 'btn-outline-success' : 'btn-success'}`} onClick={handleConvertir}>
                        <i className="fas fa-user-check mr-1"></i>
                        {mostrarConversion ? 'Ocultar conversión' : 'Convertir a trato'}
                      </button>
                      <button type="submit" className="btn btn-primary mr-2" disabled={guardando}>
                        <i className="fas fa-save mr-1"></i>
                        {guardando ? 'Guardando...' : 'Guardar gestión'}
                      </button>
                      <button type="button" className="btn btn-secondary" onClick={handleSiguiente}>
                        Siguiente lead <i className="fas fa-arrow-right ml-1"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </SpinnerLoading>
          </div>
        </div>
      </div>

      {/* Modal: gestionar llamada desde historial */}
      {modalLlamada && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="fas fa-phone mr-2 text-primary"></i>
                  Gestionar seguimiento
                </h5>
                <button type="button" className="close" onClick={handleCerrarModal}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {/* Info de la llamada */}
                <div className="alert alert-info py-2 px-3 mb-3" style={{ fontSize: 13 }}>
                  <i className="fas fa-calendar-check mr-2"></i>
                  <strong>Seguimiento programado:</strong> {(modalLlamada.fecha_hora || '').split(' ')[0]}
                  {modalLlamada.nombre_proposito && <span className="ml-3"><strong>Propósito:</strong> {modalLlamada.nombre_proposito}</span>}
                  {modalLlamada.anotaciones && <div className="mt-1"><strong>Nota previa:</strong> {modalLlamada.anotaciones}</div>}
                </div>

                {/* Cronómetro */}
                <div className="text-center mb-3">
                  <div style={{ fontSize: 36, fontWeight: 700, fontFamily: 'monospace', color: mTimerActive ? '#28a745' : '#6c757d' }}>
                    {formatTime(mSeconds)}
                  </div>
                  <small className="text-muted">Tiempo de llamada</small>
                </div>

                {/* Resultado */}
                <div className="form-group">
                  <label><strong>Resultado de la llamada:</strong></label>
                  <div className="d-flex" style={{ gap: 8 }}>
                    <button type="button"
                      className={`btn btn-sm ${mResultado === 'respondio' ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => {
                        setMResultado('respondio');
                        if (mInicioConversacion === 0) setMInicioConversacion(mSeconds);
                      }}>
                      <i className="fas fa-check mr-1"></i>Respondió
                    </button>
                    <button type="button"
                      className={`btn btn-sm ${mResultado === 'no_respondio' ? 'btn-warning' : 'btn-outline-warning'}`}
                      onClick={() => { setMResultado('no_respondio'); setMProposito('4'); }}>
                      <i className="fas fa-times mr-1"></i>No respondió
                    </button>
                  </div>
                  {mResultado && (
                    <small className={`mt-1 d-block text-${mResultado === 'respondio' ? 'primary' : 'warning'}`}>
                      {mResultado === 'respondio'
                        ? `✓ Respondió — conversación: ${formatTime(mInicioConversacion > 0 ? mSeconds - mInicioConversacion : 0)}`
                        : '✗ No respondió'}
                    </small>
                  )}
                </div>

                <div className="row">
                  <div className="col-md-6 form-group">
                    <label>Estado:</label>
                    <select className="form-control form-control-sm" value={mEstado} onChange={e => setMEstado(e.target.value)}>
                      <option value="">Seleccionar...</option>
                      {estados.map((e, i) => (
                        <option key={i} value={e.id_estado}>{e.nombre_estado}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6 form-group">
                    <label>Propósito: <span className="text-danger">*</span></label>
                    <select className="form-control form-control-sm" value={mProposito} onChange={e => setMProposito(e.target.value)}>
                      <option value="">Seleccionar...</option>
                      <option value="2">Venta</option>
                      <option value="3">Seguimiento de venta</option>
                      <option value="1">Posventa</option>
                      <option value="4">No contactado</option>
                    </select>
                  </div>
                  <div className="col-12 form-group">
                    <label>Nota de gestión:</label>
                    <textarea className="form-control form-control-sm" rows={3}
                      value={mNota} onChange={e => setMNota(e.target.value)}
                      placeholder="Anota el resultado de esta gestión..." />
                  </div>
                </div>

                {/* Programar seguimiento opcional */}
                <div className="border rounded p-2 mt-1">
                  <small className="text-muted font-weight-bold d-block mb-2">
                    <i className="fas fa-calendar-alt mr-1"></i>Programar próximo seguimiento (opcional)
                  </small>
                  <div className="row">
                    <div className="col-md-4 form-group mb-1">
                      <label className="mb-1"><small>Fecha:</small></label>
                      <input type="date" className="form-control form-control-sm"
                        value={mFechaProg} onChange={e => setMFechaProg(e.target.value)} />
                    </div>
                    <div className="col-md-4 form-group mb-1">
                      <label className="mb-1"><small>Hora:</small></label>
                      <input type="time" className="form-control form-control-sm"
                        value={mHoraProg} onChange={e => setMHoraProg(e.target.value)} />
                    </div>
                    <div className="col-md-4 form-group mb-1">
                      <label className="mb-1"><small>Motivo:</small></label>
                      <input type="text" className="form-control form-control-sm"
                        value={mMotivoProg} onChange={e => setMMotivoProg(e.target.value)}
                        placeholder="Motivo..." />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleCerrarModal} disabled={mGuardando}>
                  Cancelar
                </button>
                <button type="button" className="btn btn-primary" onClick={handleGuardarModal} disabled={mGuardando}>
                  <i className="fas fa-save mr-1"></i>
                  {mGuardando ? 'Guardando...' : 'Guardar gestión'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default DetallesLead;
